import { HttpHeaders, httpResource } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { REQUIRE_AUTH_HEADER } from '@psu-pennstateit-swe/utils/security';
import { SSRM_CONFIG } from '../../app-properties.model';
import { categoriesResponseSchema, Category } from './categories.model';

const headers = new HttpHeaders({ [REQUIRE_AUTH_HEADER]: 'true' });

@Service()
export class CategoriesData {
  private readonly ssrmConfig = inject(SSRM_CONFIG);
  private readonly baseUrl = `${this.ssrmConfig.url}categories`;

  readonly categoriesResource = httpResource<Category[]>(
    () => ({
      url: this.baseUrl,
      method: 'GET',
      headers,
    }),
    {
      parse: (response) => categoriesResponseSchema.parse(response),
    },
  );
}
